module.exports = __webpack_public_path__ + "img/800-500-fill-power.8d56f6f.svg";